interface Props {
  className?: string;
}

export default function MapPinIcon({className}: Props) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16">
      <path
        fill="currentColor"
        d="M8 0c4 0 6 3 6 6 0 2.7-2 6-6 10-4-4-6-7.3-6-10 0-3 2-6 6-6zm0 4c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
      />
    </svg>
  );
}
